<template>
  <b-popover :target="target" triggers="click blur" placement="bottom" title="" ref="popover">
    <div class="sharePopover">
      <b-button variant="secondary" class="share-btn" @click="shareFb">
        <font-awesome-icon :icon="['fab', 'facebook']" /> Facebook
      </b-button>
      <b-button variant="secondary" class="share-btn mt-1" @click="shareTw">
        <font-awesome-icon :icon="['fab', 'twitter']" /> Twitter
      </b-button>
    </div>
  </b-popover>
</template>

<style scoped lang="scss">

  .share-btn {
    display: block;
    width: 100%;
    padding: 0 1em;
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import LinkButton from '@/components/widgets/LinkButton'

export default {
  name: 'Share',
  components: {
    FontAwesomeIcon,
    LinkButton
  },
  props: {
    target: String,
    text: String,
    shareUrl: String,
    openGraph: Object
  },
  computed: {
    url () {
      return this.$store.getters['config/baseUrl'] + (this.shareUrl || this.$route.fullPath)
    }
  },
  methods: {
    close () {
      this.$refs.popover.$emit('close')
    },
    shareFb () {
      let params = {
        method: 'share',
        href: this.url
      }
      if (this.openGraph) params.object = this.openGraph
      window.FB.ui(params, response => {})
    },
    shareTw () {
      let shareUrl = 'http://twitter.com/share?'
      let params = {
        url: this.url,
        text: this.text || '',
        via: 'songback'
      }

      for (let prop in params) {
        shareUrl += '&' + prop + '=' + encodeURIComponent(params[prop])
      }

      window.open(shareUrl, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Share.vue